import React from "react";
import { Chart } from "primereact/chart";
import { Divider } from "primereact/divider";
import { getCategoriesPerClientOptions } from "../../../../utils/chartOptions/dashboard/adminDashboard";
import ChartSkeleton from "../../../Skeletons/ChartSkeleton";

const CategoriesPerClientChart = React.memo(function CategoriesPerClient({
  categoriesPerClientGraphData,
  loading,
}) {
  const options = getCategoriesPerClientOptions(categoriesPerClientGraphData);

  return (
    <>
      <div className="m-4" style={{ maxWidth: "100%" }}>
        <div className="mb-4">
          <div className="col-12 pb-5">
            {loading ? (
              <ChartSkeleton />
            ) : (
              <Chart
                type="bar"
                data={categoriesPerClientGraphData}
                options={options}
                redraw={String(false)}
              />
            )}
          </div>
          <Divider />
        </div>
      </div>
    </>
  );
});

export default CategoriesPerClientChart;
